import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'

import {
  cross,
  plus,
  minus,
  IconAddRow,
  IconAdvanceSearchBar,
  IconFilterChips,
  IconReply,
  IconTrashAdvSearch,
  IconClose4,
} from '../../../assets/images/icons'
import { SearchBox, MuiMultiSelect, MuiButton } from '../../../components'

import {
  OuterWrapper,
  SelectedFilters,
  SelectedChip,
  ActionFilters,
  MenuOuterWrapper,
  MenuInnerWrapper,
  AccordionWrapper,
  AccordionContent,
  AccordionHeading,
} from './style'

const Filter = (props) => {
  const { accordionHeading, onChange, onSearch, onReset, onChangeSelectAll, showRHS } = props

  const [expanded, setExpanded] = useState(false)
  const [anchorElUser, setAnchorElUser] = useState(null)

  const filterDataLen = accordionHeading.map((a) => a.data).flat(1)
  const filterIndexLen = accordionHeading.map((a) => a.filterIndex).flat(1)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget)
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null)
  }

  const HandlerChangeCheckBox = (e, o) => {
    onChange({ ...o, checked: e.target.checked })
  }

  const HandlerDeleteClick = (e, o) => {
    onChange({ ...o, checked: false })
  }

  const handlerSearchBox = (e) => {
    onSearch(e)
  }

  const applyFilter = () => {
    handleCloseUserMenu()
  }

  const onChangeSelect = (index, type, array) => {
    const filterIndex = accordionHeading[index].filterIndex
    const dataValues = accordionHeading[index].data.map((d) => d[type])

    const arraySet = new Set(array)

    // Find common values
    const common = dataValues.filter((value) => arraySet.has(value))

    // Find unique values between `filterIndex` and `array`
    const filterIndexSet = new Set(filterIndex)
    const unique = [
      ...filterIndex.filter((value) => !arraySet.has(value)),
      ...array.filter((value) => !filterIndexSet.has(value)),
    ]

    // Get first unique value and whether it's in common
    const val = unique[0]
    const obj = { [type]: val, checked: common.includes(val) }

    onChange(obj)
  }

  return (
    <OuterWrapper showRHS={showRHS}>
      <ActionFilters>
        <SearchBox onClick={handlerSearchBox} />
        {accordionHeading?.length > 0 &&
          accordionHeading.map((accordion, index) => {
            return (
              <MuiMultiSelect
                key={index}
                name={accordion.sortKey}
                placeholder={accordion.field}
                onChange={(e) => onChangeSelect(index, accordion.sortKey, e)}
                onSelectAll={(e) => onChangeSelectAll(e, accordion.sortKey)}
                // title={accordion.field}
                data={accordion.data.map((d) => d[accordion.sortKey])}
                value={accordion.filterIndex}
                style={{ width: '20%' }}
              />
            )
          })}
      </ActionFilters>

      {filterIndexLen.length > 0 && filterIndexLen.length !== filterDataLen.length && (
        <SelectedFilters>
          <IconFilterChips />
          {accordionHeading.map((a) => {
            return a.data.map((b, i) => {
              return (
                <div key={i}>
                  {b.checked && (
                    <SelectedChip onClick={(e) => HandlerDeleteClick(e, { ...b, key: a.sortKey })}>
                      {b[a.sortKey]}
                      <IconClose4 />
                    </SelectedChip>
                  )}
                </div>
              )
            })
          })}
          <MuiButton
            variant='text'
            size='small'
            color='primary'
            label='Clear All'
            onClick={() => onReset()}
          />
        </SelectedFilters>
      )}

      <MenuOuterWrapper
        className='MenuWrapper'
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        <MenuInnerWrapper>
          {accordionHeading.map((a, i) => {
            return (
              <AccordionWrapper
                key={i}
                expanded={expanded === a.sortKey}
                onChange={handleChange(a.sortKey)}
              >
                <AccordionHeading
                  expandIcon={<img src={expanded === a.sortKey ? minus : plus} width='11px' />}
                >
                  <Typography sx={{ flexShrink: 0 }}>{a.field}</Typography>
                </AccordionHeading>
                <AccordionContent>
                  {a.data.map((object, j) => (
                    <FormControlLabel
                      key={j}
                      control={
                        <Checkbox
                          size='medium'
                          variant='outlined'
                          color='dark'
                          defaultChecked={object.checked}
                        />
                      }
                      label={object[a.sortKey]}
                      onClick={(e) => HandlerChangeCheckBox(e, object)}
                    />
                  ))}
                </AccordionContent>
              </AccordionWrapper>
            )
          })}
        </MenuInnerWrapper>
      </MenuOuterWrapper>
    </OuterWrapper>
  )
}

export default Filter
